import { render, staticRenderFns } from "./Longevity.vue?vue&type=template&id=63666638&scoped=true&"
import script from "./Longevity.vue?vue&type=script&lang=ts&"
export * from "./Longevity.vue?vue&type=script&lang=ts&"
import style0 from "./Longevity.vue?vue&type=style&index=0&id=63666638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63666638",
  null
  
)

export default component.exports